export default {
  signals: {
    temperature: {
      label: {
        notes: 'Label for dTemperature signal',
        message: 'Temperature',
      },
    },
    batteryPercent: {
      label: {
        notes: 'Label for dBatteryPercent signal',
        message: 'Battery',
      },
    },
    workTime: {
      label: {
        notes: 'Label for iWorkTime signal',
        message: 'Total work hours',
      },
    },
    impactTime: {
      label: {
        notes: 'Label for iImpactTime signal',
        message: 'Total impact hours',
      },
    },
    impactSeriesTime0to2s: {
      label: {
        notes: 'Label for iImpactSeriesTime0-2s signal',
        message: 'Impacts series: Acceptable (0-2s)',
      },
    },
    impactSeriesTime2to5s: {
      label: {
        notes: 'Label for iImpactSeriesTime2-5s signal',
        message: 'Impacts series: Good (2-5s)',
      },
    },
    impactSeriesTime5to15s: {
      label: {
        notes: 'Label for iImpactSeriesTime5-15s signal',
        message: 'Impacts series: Optimal (5-15s)',
      },
    },
    impactSeriesTime15to30s: {
      label: {
        notes: 'Label for iImpactSeriesTime15-30s signal',
        message: 'Impacts series: Minor warning (15-30s)',
      },
    },
    impactSeriesTime30to60s: {
      label: {
        notes: 'Label for iImpactSeriesTime30-60s signal',
        message: 'Impacts series: Major warning (30-60s)',
      },
    },
    impactSeriesTime60s: {
      label: {
        notes: 'Label for iImpactSeriesTime60s signal',
        message: 'Impacts series: Critical (≥60s)',
      },
    },
  },
};
